// Module
var code = "<template>\n    <div v-once></div>\n  </template>";
// Exports
module.exports = code;